/* @flow */
import {
  SET_OPTIONS,
  SET_ACTIVITY,
  SET_TIMEOUT_WARNING,
  INITIALIZE,
  CONFIRMATION,
  SET_LAST_ROUTE,
  LOGIN,
  LOGOUT,
  ACCEPT_TERMS,
  CHANGE_PASSWORD_CREDENTIALS_UPDATE,
  CHANGE_PASSWORD,
  MFA_VERIFY_RESPONSE,
  FORGOT_PASSWORD,
  LOGIN_CLEAR_STATUS_MESSAGE,
  DECLINE_TERMS,
  FORCE_LOGIN,
  DID_LOGIN_VIA_SSO,
  CLIPBOARD_COPY,
  SET_THEME_FROM_PREFERENCES,
} from './action-types.js';

import type {
  OptionsShape,
  ActivityShape,
  LoginObjectType,
  LogoutObjectType,
  MfaVerifyResponsePayloadType,
  ChangePasswordRequestType,
  ForgotPasswordRequestType,
  RedirectAfterAuthVerifiedType,
} from './types.js';
import {CONFIRM_ALIVE} from './action-types';

export const initialize = () => ({ type: INITIALIZE });

export const closeTimeoutWarning = () => ({
  type: SET_TIMEOUT_WARNING,
  payload: false,
});

export const setOptions = (options: OptionsShape) => ({
  type: SET_OPTIONS,
  payload: options,
});

export const setThemeFromPreferences = (themeFromPreferences: string) => ({
  type: SET_THEME_FROM_PREFERENCES,
  payload: themeFromPreferences,
});

export const setActivity = (activity: ActivityShape) => ({
  type: SET_ACTIVITY,
  payload: activity,
});

export const setLastRoute = (route: string) => ({
  type: SET_LAST_ROUTE,
  payload: route,
});

export const confirm = (payload: Object) => ({
  type: CONFIRMATION,
  payload,
});

export const login = (payload: LoginObjectType) => ({
  type: LOGIN,
  payload,
});

export const logout = (comingFrom?: LogoutObjectType) => ({
  type: LOGOUT,
  payload: comingFrom,
});

export const acceptTerms = () => ({
  type: ACCEPT_TERMS,
});

export const declineTerms = () => ({
  type: DECLINE_TERMS,
});

export const changePasswordUpdateCredentials = (password: string) => ({
  type: CHANGE_PASSWORD_CREDENTIALS_UPDATE,
  payload: password,
});

export const mfaVerifyResponse = (payload: MfaVerifyResponsePayloadType) => ({
  type: MFA_VERIFY_RESPONSE,
  payload,
});

export const changePassword = (payload: ChangePasswordRequestType) => ({
  type: CHANGE_PASSWORD,
  payload,
});

export const forgotPassword = (payload: ForgotPasswordRequestType) => ({
  type: FORGOT_PASSWORD,
  payload,
});

export const clearLoginStatusMessage = () => ({
  type: LOGIN_CLEAR_STATUS_MESSAGE
});

export const forceLogin = (intendedPath: string = '/') => ({
  type: FORCE_LOGIN,
  payload: intendedPath,
});

export const didLoginViaSSO = (intendedPath: string = '/') => ({
  type: DID_LOGIN_VIA_SSO,
  payload: intendedPath,
});

export const clipboardCopy = (payload?: boolean) => ({
  type: CLIPBOARD_COPY,
  payload
});

// Using session endpoint, will replace with WHOAMI endpoint when it's ready on BE
// Verify auth is meant to check if you are authorized before allowing a dozen API calls that will
// result in a 401 / 403 be fired
export const verifyAuth = (comingFrom?: RedirectAfterAuthVerifiedType) => ({
  type: CONFIRM_ALIVE,
  payload: comingFrom,
});




// WEBPACK FOOTER //
// ./src/app/modules/app/actions.js